import { render, staticRenderFns } from "./SelectProject.vue?vue&type=template&id=0bff149d&"
import script from "./SelectProject.vue?vue&type=script&lang=js&"
export * from "./SelectProject.vue?vue&type=script&lang=js&"
import style0 from "./SelectProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports